import React, { useContext } from 'react';
import { css } from '@emotion/core';
import t from 'react-translate';

// redux
import { NQuizQuestion, QuizQuestionType } from 'redux/schemas/models/quiz';

import QuestionSetContext from 'lecture_pages/services/question-set-context';
import { halfSpacing } from 'styles/global_defaults/scaffolding';
import useQuestionSetHelpers from 'quizzes/hooks/use-question-set-helpers';
import NvIcon from 'shared/components/nv-icon';
import NvTooltip from 'shared/components/nv-tooltip';
import { QuestionNavigatorItemProps } from './question-navigator-item';

type LearnerNavigationContentProps = Pick<QuestionNavigatorItemProps, 'disabled' | 'index' | 'active'> & {
  isCorrect: boolean,
  isWrong: boolean,
};

const LearnerNavigationContent = (props: LearnerNavigationContentProps) => {
  const { index, active, isCorrect, isWrong, disabled } = props;
  const { questions } = useContext(QuestionSetContext);
  const currentQuestion: NQuizQuestion = questions[index];

  const {
    isAnswerMode,
  } = useQuestionSetHelpers();

  const styles = css`
    // Overriding icon font size
    .extra-small-icon {
      font-size: ${halfSpacing}px;
    }
  `;

  const getContent = () => {
    if (isCorrect) {
      return <NvIcon icon='check' size='smallest' className='text-success' />;
    }
    if (isWrong) {
      return (
        <NvIcon
          icon='close'
          size='smallest'
          className='extra-small-icon text-danger'
        />
      );
    }

    return currentQuestion.displayIndex;
  };
  const getStatementIconColor = () => {
    if (active) {
      return 'white';
    }
    if (disabled && !isAnswerMode) {
      return 'gray-4';
    }
    return 'gray-2';
  };

  return (
    <span css={styles}>
      {(currentQuestion?.type === QuizQuestionType.STATEMENT) ? (
        <NvTooltip
          text={t.QUIZZES.PROGRESSIVE_QUIZ_BASICS.STATEMENT()}
          offset={active ? 5 : 0}
        >
          <NvIcon
            icon='read'
            size='smallest'
            className={`text-${getStatementIconColor()}`}
          />
        </NvTooltip>
      ) : getContent()}
    </span>
  );
};

export default LearnerNavigationContent;
